// extracted by mini-css-extract-plugin
module.exports = {"footer":"style__footer__2SNqh","section":"style__section__UtjA+"};